export class HistoryStateUtils{

    public static addSavedStateToUrlPathIfNecessary(draftSubmissionId: string) {
        const pathArray = window.location.pathname.split('/').filter(Boolean);
        if (pathArray[2] === undefined || pathArray[2] === "") {
            window.history.replaceState(null, "",
                `${window.location.origin}/${pathArray[0]}/${pathArray[1]}/${draftSubmissionId}`)
        }
    }

    public static removeSavedStateFromUrlPath() {
        const pathArray = window.location.pathname.split('/').filter(Boolean);
        if (pathArray[2] !== undefined && pathArray[2] !== "") {
            window.history.replaceState(null, "",
                `${window.location.origin}/${pathArray[0]}/${pathArray[1]}`)
        }
    }
}